export default "../images/loans.svg?96f4fc812d666af3e20a9c1a065b51e4";